import React, { useState } from 'react'
import Box from '@material-ui/core/Box'

import SharedForm from '../../../shared/SharedForm'
import Input from '../../../shared/inputs/Input'
import { resendOTPClick, saveWithOTPClick } from '../saveRetirementScenarioHelpers'

export const VerifyOtpScreen = (props) => {
  const [savingInProgress, setSavingInprogress] = useState(false)
  const [errorMessage, setErrorMessage] = useState(false)

  return (
    <div className='save-scenario-dialog__verify-otp'>
      <h1>One-Time Pin Confirmation</h1>
      <div className='row'>
        <div className='small-12 columns'>
          <VerifyOtpParagraph {...props} />
          <VerifyOtpInput
            errorMessage={errorMessage}
            setErrorMessage={setErrorMessage}
            {...props}
          />
          <VerifyOtpForm
            setErrorMessage={setErrorMessage}
            savingInProgress={savingInProgress}
            setSavingInprogress={setSavingInprogress}
            {...props}
          />
        </div>
      </div>
    </div>
  )
}

const VerifyOtpParagraph = (props) =>
  <p>
    We have sent an OTP to {props.clientPronoun} number that we have on record: +{props.clientCellphoneNumber}
  </p>

const VerifyOtpInput = (props) =>
  <div className='verify-otp__input'>
    <Input
      name='otp_input' id='otp_input'
      label='Enter your OTP' isHalf value={props.Otp}
      onChange={props.setOtp}
    />
    {props.errorMessage && <p className='error'>{props.errorMessage}</p>}
  </div>

const VerifyOtpForm = (props) =>
  <SharedForm id='otp-form' actionUrl={props.url} methodType='POST' authenticityToken={props.authenticityToken}>
    <input type='hidden' name='_method' value={props.method} />
    <input type='hidden' name='implement' value='true' />
    <input type='hidden' name='retirement_scenario[risk_profile[consent_given]]' value='true' />
    <Input
      hidden name='retirement_scenario[name]' id='retirement_scenario_name_input'
      label='give your plan a name' isHalf={false}
      value={props.scenarioName} onChange={(value) => props.setScenarioName(value)}
    />

    {props.isWealthManager && props.sendImplementationNoticeToClient &&
      <div className='row'>
        <div style={{ float: 'right', marginBottom: '2rem', marginTop: '-1rem', marginRight: '1rem' }}>
          <input
            type='hidden'
            id='client_send_implement_notification_input'
            name='send_implement_notification'
            value={props.sendImplementationNoticeToClient}
            label='notify client of changes when implementing'
            onChange={(value) => props.setSendImplementationNoticeToClient(value)}
          />
        </div>
      </div>}

    {props.isWealthManager && props.advisorDeclarationAcceptance &&
      <div className='row'>
        <div style={{ float: 'right', marginBottom: '2rem', marginTop: '-1rem', marginRight: '1rem' }}>
          <input
            type='hidden'
            id='advisor_delcaration_acceptance_input'
            name='advisor_declaration_acceptance'
            value={props.advisorDeclarationAcceptance}
          />
        </div>
      </div>}

    <div className='row'>
      <Box
        className='flex gap-4'
      >
        <ResendOTP
          {...props}
          onClick={() => resendOTPClick(props)}
          savingInProgress={props.savingInProgress}
        />
        <SaveWithOTP
          {...props}
          onClick={() => saveWithOTPClick(props)}
          savingInProgress={props.savingInProgress}
        />
      </Box>
    </div>
  </SharedForm>

const ResendOTP = (props) =>
  <input
    value={`${props.savingInProgress ? 'Implementing...' : 'Resend my OTP'}`}
    type='button'
    className={`full-width button ${props.savingInProgress ? 'disabled' : 'button--secondary'}`}
    onClick={props.onClick}
    data-tracking='true'
    data-event='Resend OTP in Scenario Planning'
    data-event-details={`{"client_id": ${props.clientId}, "retirement_scenario_id": ${props.retirementScenarioId}}`}
  />

const SaveWithOTP = (props) =>
  <input
    value={`${props.savingInProgress ? 'Implementing...' : 'Verify OTP & implement'}`}
    type='button'
    className={`full-width button ${props.savingInProgress ? 'disabled' : ''}`}
    onClick={props.onClick}
    data-tracking='true'
    data-event='Confirm Risk change with OTP'
    data-event-details={`{"client_id": ${props.clientId}, "retirement_scenario_id": ${props.retirementScenarioId}}`}
  />
